import { useEffect, useState } from "react";

let show: ((text: string) => void) | null = null;

/** Короткое подтверждение внизу экрана («Сохранено», «Удалено»). */
export function toast(text: string): void {
  show?.(text);
}

export function ToastHost() {
  const [text, setText] = useState<string | null>(null);

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout> | undefined;
    show = (next) => {
      setText(next);
      clearTimeout(timer);
      timer = setTimeout(() => setText(null), 2500);
    };
    return () => {
      show = null;
      clearTimeout(timer);
    };
  }, []);

  return text ? (
    <div className="toast" role="status">
      {text}
    </div>
  ) : null;
}
